import React from "react";
import ReactTooltip from "react-tooltip";

const EmbedVideo = ({
  onEmbedVideoClick,
  embedCopy,
  embedToolTipPlacement,
  embedToolTip,
}) => {
  return (
    <>
      <div
        className="share-item"
        onClick={onEmbedVideoClick}
        data-tip
        data-for="embedPlaylist"
      >
        <i
          className={"fas text-white " + (embedCopy ? "fa-check" : "fa-code")}
        ></i>
      </div>
      <ReactTooltip
        id="embedPlaylist"
        type="dark"
        place={embedToolTipPlacement}
        effect="solid"
      >
        <span>{embedToolTip}</span>
      </ReactTooltip>
    </>
  );
};
export default EmbedVideo;
